import React, { useState, useEffect } from 'react'
import { Box, Typography, Grid, TextField, MenuItem, Checkbox, Button } from '@mui/material';
import { AiOutlineLeft } from "react-icons/ai";
import { formatPhoneNumber } from '../../components/formatPhone';
import SignatureCanvas from 'react-signature-canvas';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import Loader from '../../components/loader';
import ButtonComponent from '../../components/loaderNew';

const useStyles = makeStyles(theme => ({
    PatientNextButton: {
        display: "flex",
        flexDirection: "column",
        marginTop: 50,
        justifyContent: "center",
        //marginBottom:20
    },
    createAccountButton: {
        height: 74,
        width: "534px",
        borderRadius: 10,
        fontFamily: 'Manrope',
        fontStyle: 'normal',
        fontWeight: 200,
        fontSize: 24,
        color: "#FFFFFF",
        textTransform: "none",
    },
    mainTitle: {
        textAlign: "left",
        fontFamily: 'Manrope',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 20,
        display: "flex",
        justifyContent: "space-between",
        color: "#000000",
    },
    backArrow: {
        fontFamily: 'Manrope',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: 24,
        display: "flex",
        alignItems: "center",
        color: "#024C9C",
        textDecoration: "none",
    }
}));


const ConsentForm1 = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector(state => state.patientReducer.loading);
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const patientDetails = useSelector(state => state.patientReducer.patientDetails);
    const {
        managingOrganization,
        address,
        gender,
        name,
        photo,
        birthDate,
        telecom,
        identifier,
        extension,
        meta } = patientDetails || {};
    const consentsData = useSelector(state => state.patientReducer.consentsData);

    const [cellPhone, setCellPhone] = useState(telecom && telecom[0] && telecom[0].use === 'mobile' && telecom[0].value !== 'N/A' && telecom[0].value || '');
    const [firstName, setFirstName] = useState((name && name[0] && name[0]?.given && name[0]?.given[0]) || '');
    const [lastName, setLastName] = useState((name && name[0]?.family) || '');
    // const [email, setEmail] = useState('');
    const [dob, setDob] = useState(birthDate || '');
    const [genderr, setGender] = useState(gender || '');
    const [isFirstForm, setIsFirstForm] = useState(true);
    const [financialConsent, setFinancialConsent] = useState(false);
    const [treatmentConsent, setTreatmentConsent] = useState(false);
    const [nPPConsent, setNPPConsent] = useState(false);
    const [signatureBase64, setSignatureBase64] = useState('');
    const [isWriteSignature, setIsWriteSignature] = useState(false);
    const [signatureRef, setSignatureRef] = useState('');
    const [isFinancialConsentRead, setFinancialConsentRead] = useState(false);
    const [isTreatmentConsentRead, setTreatmentConsentRead] = useState(false);
    const [isNPPConsentRead, setNPPConsentRead] = useState(false);
    const [sigPad, setSigPad] = useState(null);
    const [register, setRegister] = useState('');
    const [retired, setRetired] = useState('');
    const [status, setStatus] = useState('');
    const [emaill, setEmail] = useState(telecom && ((telecom[1] && telecom[1].system === 'email' && telecom[1].value !== 'N/A' && telecom[1].value) || (telecom[0] && telecom[0].system === 'email' && telecom[0].value !== 'N/A' && telecom[0].value)) || '');
    const [physicianAddress, setPhysicianAddress] = useState('');
    const [reasonVisit, setReasonVisit] = useState('');
    const [accident, setAccident] = useState('');
    const [homePhone, setHomePhone] = useState(telecom && telecom[2] && telecom[2].value !== 'N/A' && telecom[2].value || '');
    const [concentLeave, setConcentMsg] = useState('');
    const [msgCallBack, setMsgCallBack] = useState('');
    const [isProfileUpdate, setIsProfileUpdate] = useState(false);
    const [required, setRequired] = useState('');
    // const [street, setStreet] = useState(
    //     (address && address[0]?.line?.[0]) || '',
    // );

    // const [city, setCity] = useState(address && address[0].city);
    // const [state, setState] = useState(address && address[0].state);
    // const [postalCode, setPostalCode] = useState(
    //     address && address[0].postalCode,
    // );
    const genderList = [{
        "name": "Male",
        "value": "male"
    },
    {
        "name": "Female",
        "value": "female"
    }];

    const onSigned = () => {
        const signature = sigPad.getTrimmedCanvas().toDataURL('image/png');
        setSignatureBase64(signature);
        setRequired('!signature')
    };

    useEffect(() => {
        if (consentsData) {
            navigate('/room/medicalHistory');
            dispatch(patientActions.addUserConsentsDetailsFailed([]));
        }
    }, [consentsData])
    const onSaveSconsents = () => {
        const payload = {
            fhir_patient_id: fhir_patient_id,
            retired: retired === 'Yes' ? true : false,
            marital_status: status ? status : null,
            detailed_message_device: concentLeave ? concentLeave : null,
            callback_device: msgCallBack ? msgCallBack : null,
            physician_office_details: physicianAddress ? physicianAddress : null,
            visit_reason: reasonVisit,
            accident_injuiry_related: accident === 'Yes' ? true : false,
            financial_consent: financialConsent ? financialConsent : null,
            treatment_consent: treatmentConsent ? treatmentConsent : null,
            practices_acknowledgement: nPPConsent ? nPPConsent : null,
            signature_image: signatureBase64 ? signatureBase64.replace('data:image/png;base64,', '') : null

        }
        dispatch(patientActions.addUserConsentsDetails(payload, userData.token));
    }

    const onNextSubmit = (e) => {
        e.preventDefault();
        if (retired === '') {
            setRequired('retired');
            return
        }
        if (reasonVisit === '') {
            setRequired('reasonVisit');
            return
        }
        if (accident === '') {
            setRequired('accident');
            return
        }
        setRequired('');
        setIsFirstForm(false)
    }
    const onHandleSubmit = (e) => {
        e.preventDefault();
        if (!financialConsent) {
            setRequired('financialConsent');
            window.scrollTo(0, 0);
            return
        }
        if (!treatmentConsent) {
            setRequired('treatmentConsent');
            window.scrollTo(0, 0);
            return
        }
        if (!nPPConsent) {
            setRequired('nPPConsent');
            window.scrollTo(0, 0);
            return
        }
        if (!signatureBase64.replace('data:image/png;base64', '')) {
            setRequired('signature');
            return
        }
        setRequired('');
        onSaveSconsents();
    }
    return (
        <div style={{ padding: '10%' }}>
            {isFirstForm ? <Box>
                <div style={{
                    width: "100%",
                    backgroundColor: "white",
                    //height: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <Typography style={{
                        textAlign: "left",
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        fontSize: 28,
                        display: "flex",
                        justifyContent: "space-between",
                        color: "#000000",
                    }} >User Details
                            <a href="" className={classes.backArrow} onClick={(e) => { e.preventDefault(); navigate('/room/patient') }}>
                            <AiOutlineLeft />Back</a>
                    </Typography>
                </div>
                <div style={{ marginTop: 20 }}>
                    <Grid item >
                        <Grid container style={{ width: '100%', justifyContent: 'space-between' }}>
                            <TextField
                                label="First Name"
                                variant='standard'
                                required
                                value={firstName}
                                onChange={e => setFirstName(e.target.value)}
                                style={{ width: '45%', marginRight: 10 }}
                                disabled={true}
                            />
                            <TextField
                                label="Last Name"
                                variant='standard'
                                required
                                value={lastName}
                                onChange={e => setLastName(e.target.value)}
                                style={{ width: '45%' }}
                                disabled={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
                        <TextField
                            label="DOB"
                            variant='standard'
                            required
                            value={dob}
                            //inputProps={{ max: getAdultDate() }}
                            type='date'
                            onChange={e => setDob(e.target.value)}
                            style={{ width: '45%', marginRight: 10 }}
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                        />
                        <TextField
                            label="Gender"
                            variant='standard'
                            required
                            select
                            value={genderr}
                            onChange={e => setGender(e.target.value)}
                            style={{ width: '45%' }}
                            disabled={true}
                        >
                            {genderList.map(({ value, name }) => (
                                <MenuItem value={value} key={value}>
                                    {name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
                        <Grid style={{ width: '45%', marginRight: 10 }}>
                            <Typography style={{ color: 'grey' }}>Retired*</Typography>
                            <div onChange={(e) => setRetired(e.target.value)} style={{ marginTop: 10, width: '100%', justifyContent: 'space-between' }}>
                                <input type="radio" value="Yes" checked={retired === 'Yes' ? true : false} name="retired" /> Yes
                                <input style={{ marginLeft: 20 }} checked={retired === 'No' ? true : false} type="radio" value="No" name="retired" /> No
                            </div>
                            {required === 'retired' && <Typography style={{
                                color: 'red', fontSize: 14, fontFamily: 'Manrope',
                                fontStyle: 'normal',
                            }}>Retired field is required</Typography>}
                        </Grid>
                        <TextField
                            label="Home Phone"
                            variant='standard'
                            type="phone"
                            value={homePhone}
                            onChange={e => { formatPhoneNumber(e.target.value, setHomePhone) }}
                            style={{ width: '45%' }}
                            disabled={telecom && telecom[2] && telecom[2].value !== 'N/A' && telecom[2].value ? true : false}
                        />
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
                        <Grid style={{ width: '100%', marginRight: 10 }}>
                            <Typography style={{ color: 'grey' }}>Marital Status</Typography>
                            <div onChange={(e) => setStatus(e.target.value)} style={{ marginTop: 10, justifyContent: 'space-between' }}>
                                <input type="radio" value="Single" checked={status === 'Single' ? true : false} name="status" /> Single
                                    <input style={{ marginLeft: 20 }} checked={status === 'Married' ? true : false} type="radio" value="Married" name="status" /> Married
                                    <input style={{ marginLeft: 20 }} checked={status === 'Divorced' ? true : false} type="radio" value="Divorced" name="status" /> Divorced
                                    <input style={{ marginLeft: 20 }} checked={status === (`Widowed` || 'Widower') ? true : false} type="radio" value={gender === 'Female' ? `Widowed` : 'Widower'} name="status" /> {gender === 'Female' ? `Widowed` : 'Widower'}
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
                        <TextField
                            label="Email"
                            variant='standard'
                            type="email"
                            value={emaill}
                            onChange={e => setEmail(e.target.value)}
                            style={{ width: '45%', marginRight: 10 }}
                            disabled={telecom && ((telecom[1] && telecom[1].system === 'email' && telecom[1].value !== 'N/A' && telecom[1].value) || (telecom[0] && telecom[0].system === 'email' && telecom[0].value !== 'N/A' && telecom[0].value)) ? true : false}
                        />
                        <TextField
                            label="Phone"
                            variant='standard'
                            type="phone"
                            value={cellPhone}
                            onChange={e => { formatPhoneNumber(e.target.value, setCellPhone) }}
                            style={{ width: '45%' }}
                            disabled={telecom && telecom[0] && telecom[0].use === 'mobile' && telecom[0].value !== 'N/A' && telecom[0].value ? true : false}
                        />
                    </Grid>
                    <Grid container style={{ width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
                        <Grid style={{ width: '45%', marginRight: 10 }}>
                            <Typography style={{ color: 'grey' }}>Consent to leave detailed message on</Typography>
                            <div onChange={(e) => setConcentMsg(e.target.value)} style={{ marginTop: 10, justifyContent: 'space-between' }}>
                                <input checked={concentLeave === 'Home' ? true : false} type="radio" value="Home" name="leave" /> Home
                                <input checked={concentLeave === 'Cell' ? true : false} style={{ marginLeft: 20 }} type="radio" value="Cell" name="leave" /> Cell
                                <input checked={concentLeave === 'None' ? true : false} style={{ marginLeft: 20 }} type="radio" value="None" name="leave" /> None
                        </div>
                        </Grid>
                        <Grid style={{ width: '45%' }}>
                            <Typography style={{ color: 'grey' }}>Message requesting call back</Typography>
                            <div onChange={(e) => setMsgCallBack(e.target.value)} style={{ marginTop: 10, justifyContent: 'space-between' }}>
                                <input checked={msgCallBack === 'Home' ? true : false} type="radio" value="Home" name="callback" /> Home
                                <input checked={msgCallBack === 'Cell' ? true : false} style={{ marginLeft: 20 }} type="radio" value="Cell" name="callback" /> Cell
                                <input checked={msgCallBack === 'None' ? true : false} style={{ marginLeft: 20 }} type="radio" value="None" name="callback" /> None
                        </div>
                        </Grid>
                    </Grid>
                    <Grid item >
                        <Grid container style={{ width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
                            <TextField
                                label="Primary Care Physician & Office"
                                variant='standard'
                                value={physicianAddress}
                                onChange={e => setPhysicianAddress(e.target.value)}
                                style={{ width: '45%', marginRight: 10 }}
                            />
                            <Grid style={{ width: '45%' }}>
                                <TextField
                                    label="Reason for your visit"
                                    variant='standard'
                                    required
                                    value={reasonVisit}
                                    onChange={e => setReasonVisit(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                                {required === 'reasonVisit' && <Typography style={{
                                    color: 'red', fontSize: 14, fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                }}>Reason for your visit field is required</Typography>}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
                        <Typography style={{ color: 'grey' }}>Is it related to work or motor vehicle accident/injury ?*</Typography>
                        <div onChange={(e) => setAccident(e.target.value)} style={{ marginTop: 10, justifyContent: 'space-between' }}>
                            <input checked={accident === 'Yes' ? true : false} style={{ marginLeft: 20 }} type="radio" value="Yes" name="accident" /> Yes
                            <input checked={accident === 'No' ? true : false} style={{ marginLeft: 20 }} type="radio" value="No" name="accident" /> No
                        </div>
                        {required === 'accident' && <Typography style={{
                            color: 'red', fontSize: 14, fontFamily: 'Manrope',
                            fontStyle: 'normal',
                        }}>Is it related to work or motor vehicle accident/injury ? field is required</Typography>}
                    </Grid>
                    {/* <Grid className={classes.PatientNextButton}> */}
                    <ButtonComponent onClick={(e) => { onNextSubmit(e) }} loading={loading} title='Next' />
                    {/* <Button
                            size="large"
                            variant="contained"
                            color='primary'
                            fullWidth
                            style={{ width:'100%',padding:'3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: '20%', alignSelf: 'center' }}
                            disabled={loading}
                            onClick={(e) => { onNextSubmit(e) }}
                        >
                            Next
                        </Button> */}
                    {/* </Grid> */}
                </div>
            </Box>
                :
                <Box>
                    <div style={{
                        width: "100%",
                        backgroundColor: "white",
                        //height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}>
                        <Typography variant="h1" style={{
                            textAlign: "left",
                            fontFamily: 'Manrope',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: 28,
                            display: "flex",
                            justifyContent: "space-between",
                            color: "#000000",
                        }} >Consents
                            <a href="" className={classes.backArrow} onClick={(e) => { e.preventDefault(); setIsFirstForm(true) }}>
                                <AiOutlineLeft />Back</a>
                        </Typography>
                    </div>
                    <Grid>
                        <Grid style={{ width: "100%", marginTop: 20 }}>
                            <Grid container>
                                <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 28,color:'#024C9C',  } }}
                                    onChange={(e) => { setFinancialConsent(e.target.checked); }} />
                                <Button onClick={() => {
                                    setFinancialConsentRead(!isFinancialConsentRead);
                                    setTreatmentConsentRead(false);
                                    setNPPConsentRead(false);
                                }} style={{color:'#024C9C', fontSize: 18, fontFamily: 'Manrope', textDecoration: 'underline', cursor: 'pointer', marginLeft: '1%' }}>Financial Consent</Button>
                            </Grid>
                            {required === 'financialConsent' && <Typography style={{
                                color: 'red', fontSize: 14, fontFamily: 'Manrope',
                                fontStyle: 'normal',
                            }}>Required</Typography>}
                            {isFinancialConsentRead && <Grid container  >
                                <Typography style={{
                                    paddingBottom: 10,
                                    marginTop: 15,
                                    color: '#8C8C8C',
                                    fontSize: 16,
                                    fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                }}>
                                    Authorization to bill/pay: I hereby authorize Akos Urgent Care and its affiliates to release any information required in
                                    the course of my examination or treatment which could include HIV, communicable disease, or drug abuse
                                    information. I also hereby authorize payment directly to the business office of Akos Urgent Care and its affiliates for
                                    the surgical and medical benefits. If any otherwise payable to me for service rendered. I understand that I am
                                    financially responsible for all charges not covered by my insurance. Further, I understand that I am responsible for all
                                    charges in the incurred collection of my account(s) and will pay all fees involved should my accounts be placed with a
                                    collection service.
                                </Typography>
                            </Grid>}
                        </Grid>
                        <Grid style={{ width: "100%", marginTop: 10 }}>
                            <Grid container>
                                <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 28,color:'#024C9C',  } }}
                                    onChange={(e) => { setTreatmentConsent(e.target.checked); }} />
                                <Button onClick={() => {
                                    setFinancialConsentRead(false);
                                    setNPPConsentRead(false);
                                    setTreatmentConsentRead(!isTreatmentConsentRead)
                                }} style={{color:'#024C9C',  fontSize: 18, fontFamily: 'Manrope', textDecoration: 'underline', cursor: 'pointer', marginLeft: '1%' }}>Consent For Treatment</Button>
                            </Grid>
                            {required === 'treatmentConsent' && <Typography style={{
                                color: 'red', fontSize: 14, fontFamily: 'Manrope',
                                fontStyle: 'normal',
                            }}>Required</Typography>}
                            {isTreatmentConsentRead && <Grid container  >
                                <Typography style={{
                                    paddingBottom: 10,
                                    marginTop: 15,
                                    color: '#8C8C8C',
                                    fontSize: 16,
                                    fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                }}>
                                    I hereby consent to medical evaluation, testing and or treatment provided to me by staff of this facility which may
                                    also include medical and minor surgical treatment or procedures, emergency treatment, and laboratory procedures. I
                                    understand that this medical facility may use or disclose Protected Health Information (PHI) necessary to carry out
                                    treatment payment or healthcare operations. I authorize the release of any information concerning me or my child's
                                    health care, advice, and treatment provided for the purpose of evaluating and administering claims for insurance
                                    benefits. I hereby authorize the facility to electronically prescribe (e-prescribe) my prescriptions. For treatment
                                    purposes, the facility may request and utilize my medication history from other healthcare providers or third-party
                                    pharmacy benefit payers. I acknowledge that if the provider has ordered additional laboratory testing that the
                                    collected specimens will be sent to a local laboratory for testing. The facility will forward your payer information to
                                    the laboratory, but you will be responsible for the charges incurred for these services and will receive a separate bill
                                    from the laboratory. I understand that there may be a portion of the cost of Durable Medical Equipment (DME) that is
                                    not covered by my insurance and I will be responsible for the balance. Please notify staff of any barrier to effective
                                    communication or educational instruction that would prevent patient's understanding of information about their
                                    health status, treatment, or the informed decision making process, such as foreign language, hearing or speech
                                    impairment, difficulty with reading or writing, or inability to comprehend verbal instructions.
                                </Typography>
                            </Grid>}
                        </Grid>
                        <Grid style={{ width: "100%", marginTop: 10 }}>
                            <Grid container>
                                <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 28,color:'#024C9C' } }}
                                    onChange={(e) => { setNPPConsent(e.target.checked); }} />
                                <Button onClick={() => {
                                    setFinancialConsentRead(false);
                                    setTreatmentConsentRead(false);
                                    setNPPConsentRead(!isNPPConsentRead);
                                }} style={{color:'#024C9C',  fontSize: 18, fontFamily: 'Manrope', textDecoration: 'underline', cursor: 'pointer', marginLeft: '1%' }}>Notice of Privacy Practices (NPP) Acknowledgement</Button>
                            </Grid>
                            {required === 'nPPConsent' && <Typography style={{
                                color: 'red', fontSize: 14, fontFamily: 'Manrope',
                                fontStyle: 'normal',
                            }}>Required</Typography>}
                            {isNPPConsentRead && <Grid container  >
                                <Typography style={{
                                    paddingBottom: 10,
                                    marginTop: 15,
                                    color: '#8C8C8C',
                                    fontSize: 16,
                                    fontFamily: 'Manrope',
                                    fontStyle: 'normal',
                                }}>
                                    {`A Notice of Privacy Practices (NPP) is provided to all patients. This NPP identifies:\n1) How medical information may be
                                used or disclosed;\n2) Your rights to access your medical information, and request additional restrictions and
                                disclosures of that information;\n3) Your rights to complain if you believe your privacy rights have been violated; and\n4)
                                Our responsibilities for maintaining your privacy as your medical representative. I have been offered and have read a
                                copy of the facilities Notice of Privacy Practices, Patient's Rights and Responsibilities, and the Patient Payment Policy.`}
                                </Typography>
                            </Grid>}
                        </Grid>
                        <Grid style={{ width: '100%',marginTop:'3%' }} >
                            {/* <FormControl margin="normal" required fullWidth> */}
                            <Typography style={{
                                fontSize: 20,
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                fontStyle: 'normal',
                            }}>
                                Patient / Legal Guardian Signature
                            </Typography>
                            <div style={{ border: '1px dashed black', borderWidth: 1, borderColor: 'black', borderRadius: 5, width: '100%', marginTop: 15, marginLeft: '1%', padding: 5 }}>
                                <SignatureCanvas
                                    penColor="black"
                                    id="signature"
                                    onEnd={onSigned}
                                    ref={ref => {
                                        setSigPad(ref);
                                    }}
                                    canvasProps={{
                                        border: '1px solid black',
                                        padding: '1rem',
                                        borderRadius: '4px',
                                        width: '500px',
                                        height: 200,
                                    }}
                                    clearOnResize={false}
                                />
                            </div>
                            {required === 'signature' && <Typography style={{
                                color: 'red', fontSize: 14, fontFamily: 'Manrope',
                                fontStyle: 'normal',
                            }}>Signature Required</Typography>}

                            <Grid item xs={12} md={12} style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '10px 0',
                            }} >
                                <Button
                                    variant="outlined"
                                    onClick={() => { sigPad.clear(); setSignatureBase64('') }}
                                    disabled={!signatureBase64}
                                >
                                    Clear Signature
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid className={classes.PatientNextButton}>
                            <ButtonComponent onClick={(e) => { onHandleSubmit(e) }} loading={loading} title='Next' />
                            {/* <Button
                                size="large"
                                variant="contained"
                                color='primary'
                                fullWidth
                                style={{width:'100%',padding:'3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: '20%', alignSelf: 'center' }}
                                disabled={loading}
                                onClick={(e) => { onHandleSubmit(e) }}
                            >
                                Next
                        </Button> */}
                        </Grid>
                    </Grid>
                </Box>
            }
            {/* {loading && <Loader />} */}
        </div>
    )
}

export default ConsentForm1;
